'use client'
import React from 'react'
import parse from 'html-react-parser'
import classes from './server-content.module.css' // Reuse the same CSS file
import {BlogDetails} from 'types/blogs'
import Image from 'next/image'
import blogDetailsFooter from 'assets/blogs/BlogDetailsFooter.svg'
import {DemoData} from 'v1/types/home-page'
import Modal from 'v1/common-components/modal/Modal'
import BookDemoForm from 'v1/page-components/marketing/common/demo-form/BookDemoForm'

interface ServerContentProps {
  content: BlogDetails['content']
}

const defaultDemoData = {
  isFreeTrialPage: false,
  isNameRequired: true,
  heading: 'Get ZenAdmin for Free',
  buttonText: 'Submit',
  isTermAndCondition: true,
  thankYouTitle: 'Your Account Has Been Created',
  thankYouParagraph:
    'Please check your email for login details to access your ZenAdmin account. Meanwhile, you can schedule a convenient time for a personalized demo.',
}

const ServerContent = ({content}: ServerContentProps) => {
  const [demoData, setDemoData] = React.useState<DemoData>({...defaultDemoData})
  const [isModalOpen, setModalOpen] = React.useState<boolean>(false)

  const toggleDemoFormModal = (data: DemoData | null = null) => {
    setDemoData(
      data || {
        ...defaultDemoData,
      },
    )
    setModalOpen(prev => !prev)
  }
  return (
    <>
      <div className={classes.serverContent}>
        <div className={classes.contentContainer}>{parse(content?.rendered || '')}</div>
        <div className={classes.divider}></div>
        <Image
          onClick={() => toggleDemoFormModal({})}
          src={blogDetailsFooter}
          className={classes.blogDetailsFooterImage}
          alt=""
        />
      </div>
      <Modal isOpen={isModalOpen} onClose={() => setModalOpen(false)}>
        <BookDemoForm data={demoData} />
      </Modal>
    </>
  )
}

export default ServerContent
